import { FC, ReactNode } from 'react'
import {
  SevenroomsAudienceOption,
  SevenroomsAudienceOptionType,
} from './Option'

const SevenroomsAudience: FC & SevenroomsAudienceOptionType = (): ReactNode => (
  <></>
)

SevenroomsAudience.Option = SevenroomsAudienceOption

export default SevenroomsAudience
